import React from 'react'
import { Box, CircularProgress, Container } from '@mui/material'
import type { Breakpoint } from '@mui/material'

interface AdminFormLoadingProps {
  /** Container width; matches the form's own `maxWidth`. Defaults to 'md'. */
  maxWidth?: Breakpoint
}

/** Centered spinner shown while an admin edit form loads its record. */
const AdminFormLoading: React.FC<AdminFormLoadingProps> = ({ maxWidth = 'md' }) => (
  <Container maxWidth={maxWidth}>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
      <CircularProgress />
    </Box>
  </Container>
)

export default AdminFormLoading
